module.exports = __webpack_public_path__ + "static/media/radio0.d82eb0d8.svg";